// extracted by mini-css-extract-plugin
export default {"container":"XL-z","title":"YL-z","link":"ZL-z"};